import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Container } from 'semantic-ui-react'
import avatar from '../images/avatar/mark.png'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getNotes, saveNote, deleteNote } from '../redux/actions'
import { getUser } from '../redux/userActions'

const HOME_PATH = '/inCyberNotes/'
//const HOME_PATH = '/'

export class App extends Component {
  state = {
    title: '',
    body: ''
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const note = {
      title: this.state.title,
      body: this.state.body,
      uid: this.props.user.uid
    }
    this.props.saveNote(note)
    this.setState(() => ({
      title: '',
      body: '',
    }))
  }

  renderButton = () => {
    return (
      <div className="fluid ui animated button">
        <div className="visible content">Next</div>
        <div className="hidden content">
          <i className="right arrow icon" />
        </div>
      </div>
    )
  }

  removeNote = key => {
    this.props.deleteNote(key)
  }
  editNote = key => {
    this.props.history.push(`${HOME_PATH}${key}/edit`)
  }

  renderNotes = () => {
    return _.map(this.props.notes, (note, key) => {
      return (
        <div className="ui middle aligned divided animated list" key={key}>
          <div className="item">
            <div className="right floated content">
              {note.uid === this.props.user.uid && (
                <div>
                  <div className="ui button" onClick={() => this.removeNote(key)}>Remove</div>
                  <div className="ui button" onClick={() => this.editNote(key)}>Edit</div>
                </div>
              )}
            </div>

            <img className="ui avatar image" src={avatar} alt='avatar'/>
            <div className="content">
              <Link to={`${HOME_PATH}${key}`}>
                <div className="active item">{note.title}</div>
              </Link>
              {note.body}
            </div>
          </div>
        </div>
      )
    })
  }

  renderNotesInverted = () => {
    return _.map(this.props.notes, (note, key) => {
      return (
        <div key={key} className="ui segments">
          <div className="ui inverted segment">
            <div className="right floated content">
              <div className="ui button">Remove</div>
            </div>
            <div className="item">
              <div className="content">
                <div className="header">{note.title}</div>
                {note.body}
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  renderSubmitButton = () => {
    return (
      <button className="fluid ui animated button">
        <div className="visible content">Submit</div>
        <div className="hidden content">
          <i className="check circle medium icon" />
        </div>
      </button>
    )
  }

  render() {
    return (
      <div>
        <Container
          className="ui raised very padded text container segment"
          style={{ marginTop: '7em' }}
        >
          <div>
            <p className='cyberFont'>Write your CyberNote</p>
            <form onSubmit={this.handleSubmit}>
              <div className="ui form">
                <div className="field">
                  <label>Title</label>
                  <input
                    onChange={this.handleChange}
                    value={this.state.title}
                    type="text"
                    name="title"
                    placeholder="title"
                  />
                </div>
                <div className="field">
                  <label>Short Text</label>
                  <textarea
                    onChange={this.handleChange}
                    value={this.state.body}
                    type="text"
                    name="body"
                    placeholder="body"
                    rows="2"
                  />
                </div>
                {this.renderSubmitButton()}
              </div>
            </form>
            {this.renderNotes()}
          </div>
        </Container>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotes,
      saveNote,
      deleteNote,
      getUser
    },
    dispatch
  )
}

function mapState(state, ownProps) {
  return {
    notes: state.notes,
    user: state.user
  }
}

export default withRouter(connect(mapState, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/components/App.js